import * as React from "react"
import { Loader } from "semantic-ui-react"

export interface ILoaderFrameProps {
  message?: React.ReactNode;
}

const LoaderFrame = ({ message }: ILoaderFrameProps) => (
  <div className="loadingDiv">
    <Loader active={true} inline="centered" size='massive' content={message} />
  </div>
)

export default LoaderFrame
